import React, { useState, createContext, ReactNode, useContext } from "react";
import { servicesConfig, CURRENT_SERVICE_CODE, ServiceConfig } from "../config/serviceDashboardConfig";
import { useLocation } from "react-router-dom";

interface ServiceContextType {
  currentService: ServiceConfig | null;
  setCurrentService: React.Dispatch<React.SetStateAction<ServiceConfig | null>>;
}

const ServiceContext = createContext<ServiceContextType | undefined>(undefined);

export const ServiceProvider = ({ children }: { children: ReactNode }) => {
  const location = useLocation();

  const serviceIdFromPath = location.pathname.split("/")[1]; 

  const initialService =
    Object.values(servicesConfig).find(
      (s) => s.id === serviceIdFromPath
    ) || Object.values(servicesConfig).find(s => s.code === CURRENT_SERVICE_CODE);

  const [currentService, setCurrentService] = useState<ServiceConfig | null>(initialService || null);

  return (
    <ServiceContext.Provider value={{ currentService, setCurrentService }}>
      {children}
    </ServiceContext.Provider>
  );
};

export const useService = () => {
  const context = useContext(ServiceContext);
  
  if (!context) {
    throw new Error("useService must be used within ServiceProvider");
  }
  return context;
};
